import React from 'react';
import { Helmet } from 'react-helmet-async';

import { isJuhlapesu } from '../helpers/environmentUtils';

const headerInfo = isJuhlapesu
  ? {
      title: 'Juhlapesu Subscription Portal',
      name: 'Juhlapesu Subscription portal',
      content: 'Web site for handling your Juhlapesu subscription',
      manifest: '/juhlapesu-manifest.json',
      favicon: '/juhlapesu-favicon.ico',
      favicon16: '/juhlapesu-favicon-16x16.png',
      appleTouch: '/juhlapesu-apple-touch-icon.png',
    }
  : {
      title: 'Glimra Abonnemangssportal',
      name: 'Glimra Subscription portal',
      content: 'Web site for handling your Glimra subscription',
      manifest: '/glimra-manifest.json',
      favicon: '/glimra-favicon.ico',
      favicon16: '/glimra-favicon-16x16.png',
      appleTouch: '/glimra-apple-touch-icon.png',
    };

export default function PageHead() {
  return (
    <Helmet>
      <title>{headerInfo.title}</title>
      <meta name="description" content={headerInfo.content} />
      <link rel="manifest" href={headerInfo.manifest} />
      <link rel="icon" href={headerInfo.favicon} />
      <link rel="icon" sizes="16x16" href={headerInfo.favicon16} />
      <link rel="apple-touch-icon" href={headerInfo.appleTouch} />
    </Helmet>
  );
}
